import React from 'react';
import { Building2, Palette, Hammer, Layout } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Building2,
      title: 'Architecture',
      description: 'Innovative architectural designs that blend aesthetics with functionality, creating structures that stand the test of time.',
      image: 'https://images.unsplash.com/photo-1519662978799-2f05096d3636?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzYwOTQ4Nzc4fDA&ixlib=rb-4.1.0&q=85',
      features: ['Concept Development', 'Structural Design', '3D Visualization', 'Building Planning']
    },
    {
      icon: Palette,
      title: 'Interior Design',
      description: 'Transform your spaces with elegant interior designs that reflect your personality and enhance your lifestyle.',
      image: 'https://images.unsplash.com/photo-1758193783649-13371d7fb8dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbiUyMG1vZGVybnxlbnwwfHx8fDE3NjA5NDg3NzN8MA&ixlib=rb-4.1.0&q=85',
      features: ['Space Planning', 'Material Selection', 'Lighting Design', 'Furniture Consultation']
    },
    {
      icon: Hammer,
      title: 'Engineering',
      description: 'Comprehensive engineering solutions ensuring structural integrity and compliance with all technical standards.',
      image: 'https://images.unsplash.com/photo-1574848296471-28f79a036f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzYwOTQ4Nzc4fDA&ixlib=rb-4.1.0&q=85',
      features: ['Structural Engineering', 'MEP Systems', 'Quality Assurance', 'Technical Documentation']
    },
    {
      icon: Layout,
      title: 'Planning Services',
      description: 'Strategic planning services to optimize your project from concept to completion with efficiency and precision.',
      image: 'https://images.unsplash.com/photo-1760072513357-9d450e935a80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbiUyMG1vZGVybnxlbnwwfHx8fDE3NjA5NDg3NzN8MA&ixlib=rb-4.1.0&q=85',
      features: ['Project Planning', 'Budget Estimation', 'Timeline Management', 'Resource Allocation']
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-black mb-4">
            Our <span className="text-yellow-600">Services</span>
          </h2>
          <div className="w-24 h-1 bg-yellow-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We offer comprehensive solutions across architecture, interior design, engineering, and planning to bring your vision to life.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="group bg-white rounded-sm shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-500"
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className="absolute bottom-6 left-6 flex items-center gap-3">
                    <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-white">{service.title}</h3>
                  </div>
                </div>

                {/* Content */}
                <div className="p-8">
                  <p className="text-gray-700 mb-6 leading-relaxed">{service.description}</p>
                  
                  <div className="space-y-3">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-2 text-gray-600">
                        <div className="w-1.5 h-1.5 bg-yellow-600 rounded-full"></div>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center bg-black rounded-sm p-12">
          <h3 className="text-3xl font-bold text-white mb-4">
            Ready to Start Your Project?
          </h3>
          <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
            Let's discuss how we can transform your space with our expert architectural and design services.
          </p>
          <button
            onClick={() => {
              const element = document.querySelector('#contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-4 bg-yellow-600 text-white font-semibold rounded-sm hover:bg-yellow-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
          >
            Get in Touch
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;